import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { DialogWrapper } from "../ManageDataTab/ManageDataStyled";
import { Constants } from "../Content";

const ConfirmationBox = ({
  show,
  title,
  uploadType,
  message,
  handleConfirmClick,
  handleCancelClick,
  handleDownload,
  showDownload
}) => {

  return (
    <DialogWrapper
      open={show}
      onClose={handleCancelClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="paper"
      maxWidth="xs"
      fullWidth={true}
      height="100vh"
    >
      <DialogTitle id="alert-dialog-title" className="customDialogTitle">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="customDialog"
        >
          <p>
            {message}
          </p>
        </DialogContentText>
      </DialogContent>

      <DialogActions className="dialogbutton">
        <>
          <Button
            variant="outlined"
            className="rightButton"
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          {!showDownload && <Button
            variant="contained"
            color="success"
            className="confirmButton"
            type="submit"
            onClick={handleConfirmClick}
          >
            {Constants.CONFIRM}
          </Button>}
          {showDownload && <Button
            variant="outlined"
            className="confirmButton"
            type="submit"
            startIcon={<FileDownloadOutlinedIcon />}
            onClick={handleDownload}
          >
            {Constants.DOWNLOAD}
          </Button>}
        </>
      </DialogActions>
    </DialogWrapper>
  );
};

export default ConfirmationBox;
